import axios from "axios";
import { useEffect, useState } from "react";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { useLocation, useNavigate } from "react-router-dom";
import ProductPriceItem from "./product-price-item";
function ProductPricingList() {

    const [priceList, setPriceList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const product_id = location.state != null ? location.state.productId : "";
    const store_id = location.state != null ? location.state.productStoreId : "";
      
    

    useEffect(() => {
        fetchPriceList();
    }, [])

    const fetchPriceList = async () => {
        let data = await axios.get(API_CONFIG.API_HOST + `ProductPrice/list?productId=${product_id}&storeId=${store_id}`, {
            headers: API_HEADERS
        })
        setPriceList(data.data.result)
    }

    //  const onStatusChange = async () => {
    //     let status = "YES";
    //     if (item.status == "NO") {
    //       status = "YES";
    //     } else {
    //       status = "NO";
    //     }
    
    //     let requestBody = {
    //       status: status,
    //       id: item.id,
    //     };
    
    //     await axiosApi
    //       .post(API_CONFIG.API_HOST + STORE_API_PATH.PRICE_UPDATE, requestBody, {
    //         API_HEADERS,
    //       })
    //       .then((response) => {
    //         consoleLog("STORE UPODATE", response);
    //         if (response.status === 200 && response.data.status === true) {
    //           setItem(item, (item.status = status));
    //           setitemStatus(status);
    //         } else {
    //           dispatch(
    //             updateMessage({
    //               display: true,
    //               message: "Error While updating info",
    //             })
    //           );
    //         }
    //       });
    
    //     // await dispatch(createUpdateAction(requestBody)).then((response) => {
    //     //   if (response.status == true) {
    //     //     setItem(product, (product.status = status));
    //     //     setitemStatus(status);
    //     //   } else {
    //     //     dispatch(
    //     //       updateMessage({
    //     //         display: true,
    //     //         message: "Error While updating info",
    //     //       })
    //     //     );
    //     //   }
    //     // });
    //   };

    return (
        <>
            <div className="d-flex flex-row justify-content-end col-9 mt-4 p-2">
                <button className="btn btn-success"
                    onClick={() => navigate("/productPricing", { state: { productId: product_id, productStoreId: store_id } })}>Add Price</button>
            </div>
            <div className="mt-2 d-flex flex-row justify-content-center w-100">
                <div className="w-50">
                {
                    priceList && priceList.length > 0 ? priceList.map((item, i) => {
                        return (
                           <ProductPriceItem price={item} key={i} productId={product_id} storeId={store_id}/>
                        )
                    }):<>No Data</>
                }
</div>
            </div>

        </>
    )

}
export default ProductPricingList